import { cloneDeep } from 'lodash';
import ManageAccountConstants from 'client/CloudInsights/constants/ManageAccountConstants';
import moment from 'moment';

const { accountState } = ManageAccountConstants;

export default {
  /**
   * Evaluates what state an account is in based on properties:
   *  awsAccountIsActivated, awsAccountIsValidated, and created_at
   * Returns string representation of the account state.
   * @param {*} account The aws account config object from cloud insights
   */
  getAwsAccountState(account) {
    const createdAt = moment(new Date(account.createdAt));
    const currentTime = moment();

    const minutesDiff = +moment
      .utc(currentTime, 'HH:mm:ss')
      .diff(moment.utc(createdAt, 'HH:mm:ss'), 'minutes');

    const isActivated = account.awsAccountIsActivated.toLowerCase() === 'true';
    const isValidated = account.awsAccountIsValidated.toLowerCase() === 'true';

    if (isActivated && isValidated) {
      return accountState.validated;
    }
    if (isActivated && !isValidated && minutesDiff <= 30) {
      return accountState.pending;
    }
    if (isActivated && !isValidated && minutesDiff > 30) {
      return accountState.error;
    }

    return accountState.unknown;
  },

  /**
   * Massage the values event object to for presentation,
   * removing fields not meant for display to user.
   * @param {*} event - event object
   * @returns A new object for presentation, with unnecessary fields removed.
   */
  sanitizeForDisplay(event) {
    const display = cloneDeep(event);

    if (display._id) delete display._id;

    return display;
  },
};
